<template>
  <empty-state
    :icon="icon"
    :title="title"
    :description="description"
    :show-action="Boolean(actionText || $slots.action)"
    :action-text="actionText"
    :show-suggestion="Boolean(suggestion)"
    :suggestion="suggestion"
    @action="$emit('action')"
  >
    <template v-if="$slots.action" #action>
      <slot name="action" />
    </template>
  </empty-state>
</template>

<script>
import EmptyState from "@/components/common/EmptyState.vue";

export default {
  name: "HsEmptyState",
  components: { EmptyState },
  props: {
    icon: { type: String, default: "inbox" },
    title: { type: String, default: "No data found" },
    description: { type: String, default: "There is nothing to show yet." },
    actionText: { type: String, default: "" },
    suggestion: { type: String, default: "" },
  },
  emits: ["action"],
};
</script>
